import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function ReportSelection() {
  const navigate = useNavigate();
  const [selectedBlocks, setSelectedBlocks] = useState([]);
  
  // State for header data
  const [headerData, setHeaderData] = useState({
    despatchSlNo: '',
    permanentSlNo: '',
    companyName: ''
  });

  const blockItems = [
    'Block A and B',
    'Block C',
    'Block D',
    'Block E',
    'Block F',
    'Block G',
    'Block H',
    'Block I',
    'Block J',
    'Block K and L',
    'Block M and N',
    'Part II',
    'Scrutiny Sheet'
  ];

  const handleBlockSelect = (block) => {
    if (selectedBlocks.includes(block)) {
      setSelectedBlocks(selectedBlocks.filter(selected => selected !== block));
    } else {
      setSelectedBlocks([...selectedBlocks, block]);
    }
  };

  const handleBlockAAndB = () => {
    navigate('/blockAandBreport');
  };

  const handleBlockC = () => {
    navigate('/blockCreport');
  };

  const handleBlockD = () => {
    navigate('/blockDreport');
  };

  const handleBlockE = () => {
    navigate('/blockEreport');
  };

  const handleBlockF = () => {
    navigate('/blockFreport');
  };

  const handleBlockG = () => {
    navigate('/blockGreport');
  };

  const handleBlockH = () => {
    navigate('/blockHreport');
  };

  const handleBlockI = () => {
    navigate('/blockIreport');
  };

  const handleBlockJ = () => {
    navigate('/blockJreport');
  };

  const handleBlockKAndL = () => {
    navigate('/blockKAndLreport');
  };

  const handleBlockMAndN = () => {
    navigate('/blockMAndNreport');
  };
  
  const handlePartII = () => {
    navigate('/partIIreport');
  };
  
  const handleScrutinySheet = () => {
    navigate('/scrutiny-sheet');
  };
  const handlePrintBlock = (block) => {
    console.log(`Printing ${block}`);
    // Add print functionality here
  };

  const handlePrintAllBlocks = () => {
    console.log('Printing all blocks');
    navigate('/allblocksreport');
  };

  // Fetch header data from localStorage when component mounts
  useEffect(() => {
    const fetchHeaderData = () => {
      try {
        // Get form data from localStorage (stored by balanceSheet page)
        const balanceSheetData = localStorage.getItem('balanceSheetFormData');

        if (balanceSheetData) {
          const parsedData = JSON.parse(balanceSheetData);

          setHeaderData({
            despatchSlNo: parsedData.dslNo || '',
            permanentSlNo: parsedData.pslNo || '',
            companyName: parsedData.nameUnit || ''
          });
        } else {
          // If no data in localStorage, set defaults
          console.log('No balanceSheet data found in localStorage');
          setHeaderData({
            despatchSlNo: 'Not Available',
            permanentSlNo: 'Not Available',
            companyName: 'Not Available'
          });
        }
      } catch (error) {
        console.error('Error fetching data from localStorage:', error);
        setHeaderData({
          despatchSlNo: 'Error loading data',
          permanentSlNo: 'Error loading data',
          companyName: 'Error loading data'
        });
      }
    };

    fetchHeaderData();
  }, []);

  return (
    <>
      <style>
        {`
          .blocks-container {
            max-width: 1200px;
            margin: 0 auto;
            padding: 20px;
          }
          .blocks-grid {
            display: flex;
            justify-content: space-between;
            gap: 20px;
            margin-bottom: 30px;
            align-items: flex-start;
          }
          .block-column {
            display: flex;
            flex-direction: column;
            gap: 8px;
            flex: 1;
            max-width: 300px;
          }
          .block-button {
            background-color: #f5f5f5;
            border: 1px solid #ddd;
            color: #333;
            padding: 10px 12px;
            border-radius: 4px;
            font-size: 14px;
            font-weight: 500;
            cursor: pointer;
            transition: all 0.3s ease;
            text-align: center;
            min-height: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
          }
          .block-button:hover {
            background-color: #e3f2fd;
            border-color: #1976d2;
            color: #1976d2;
          }
          .block-button.selected {
            background-color: #e3f2fd;
            border: 2px solid #1976d2;
            color: #1976d2;
            box-shadow: 0 2px 4px rgba(0,0,0,0.1);
          }
          .print-button {
            background-color: #f5f5f5;
            border: 1px solid #ddd;
            color: #333;
            padding: 10px 12px;
            border-radius: 4px;
            font-size: 14px;
            font-weight: 500;
            cursor: pointer;
            transition: all 0.3s ease;
            text-align: center;
            min-height: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
          }
          .print-button:hover {
            background-color: #e8f5e8;
            border-color: #4caf50;
            color: #4caf50;
          }
          .columns-with-footer {
            display: flex;
            flex-direction: column;
            align-items: center;
            flex: 2;
          }
          .blocks-row {
            display: flex;
            justify-content: space-between;
            gap: 20px;
            width: 100%;
            max-width: 650px;
          }
          .print-all-buttons-row {
            margin-top: 15px;
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 10px;
            width: 100%;
            max-width: 300px;
          }
          .print-all-button {
            background-color: #f5f5f5;
            border: 1px solid #ddd;
            color: #333;
            padding: 10px 16px;
            border-radius: 4px;
            font-size: 14px;
            font-weight: 500;
            cursor: pointer;
            transition: all 0.3s ease;
            width: 100%;
            text-align: center;
          }
          .print-all-button:hover {
            background-color: #e8f5e8;
            border-color: #4caf50;
            color: #4caf50;
          }
          .header-section {
            background-color: #e3f2fd;
            padding: 20px;
            margin-bottom: 20px;
            border-radius: 8px;
          }
         
         
          @media (max-width: 768px) {
            .blocks-grid {
              flex-direction: column;
              gap: 30px;
            }
            .block-column {
              max-width: 100%;
            }
            .blocks-row {
              flex-direction: column;
              align-items: center;
            }
          }
        `}
      </style>
      <div className="container-fluid py-3">
        {/* Header Section */}
        <div className="card mb-3">
          <div className="card-body">
            <div className="row align-items-center">
              <div className="col-md-12 mb-3">  
                <h4 className="page_heading mb-3 pb-2 border-bottom">
                  ASI Schedule 2024-25 <span style={{ color: '#d32f2f', fontWeight: 'bold' }}>CONFIDENTIAL <i className="fa fa-lock me-2" style={{ fontSize: '20px', color: '#1976d2' }}></i></span>
                </h4>
                <h5 className="mb-0 pb-3 border-bottom"><span style={{ color: '#1976d2', fontWeight: 'bold' }}>ASI Schedule 2024-25 - Report Selection</span> </h5>
              </div>
              <div className="col-md-8">
              <div className="row">
                <div className="col-md-4 mb-2">
                  <label className="form-label mb-1" style={{ fontSize: '12px', fontWeight: '500', color: '#333' }}>
                    Despatch Sl no.:
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    value={headerData.despatchSlNo || 'Not Available'}
                    readOnly
                    style={{ backgroundColor: '#f5f5f5', border: '1px solid #ddd', fontSize: '12px' }}
                  />
                </div>
                <div className="col-md-4 mb-2">
                  <label className="form-label mb-1" style={{ fontSize: '12px', fontWeight: '500', color: '#333' }}>
                    Permanent Sl no.:
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    value={headerData.permanentSlNo || 'Not Available'}
                    readOnly
                    style={{ backgroundColor: '#f5f5f5', border: '1px solid #ddd', fontSize: '12px' }}
                  />
                </div>
                <div className="col-md-4 mb-2">
                  <label className="form-label mb-1" style={{ fontSize: '12px', fontWeight: '500', color: '#333' }}>
                    Name of Company:
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    value={headerData.companyName || 'Not Available'}
                    readOnly
                    style={{ backgroundColor: '#f5f5f5', border: '1px solid #ddd', fontSize: '12px' }}
                  />
                </div>
              </div>
            </div>
            </div>
          </div>
        </div>


        {/* Blocks Selection Grid */}
        <div className="blocks-container">
          <div className="blocks-grid">
            {/* Left Column - Block Selection */}
            <div className="block-column">
              <h6 style={{ color: '#1976d2', marginBottom: '15px', textAlign: 'center' }}>Select Blocks</h6>
              {blockItems.map((block, index) => (
                <button
                  key={index}
                  className={`block-button ${selectedBlocks.includes(block) ? 'selected' : ''}`}
                  onClick={() => {
                    if (block === 'Block A and B') {
                      handleBlockAAndB();
                    } else if (block === 'Block C') {
                      handleBlockC();
                    } else if (block === 'Block D') {
                      handleBlockD();
                    } else if (block === 'Block E') {
                      handleBlockE();
                    } else if (block === 'Block F') {
                      handleBlockF();
                    } else if (block === 'Block G') {
                      handleBlockG();
                    } else if (block === 'Block H') {
                      handleBlockH();
                    } else if (block === 'Block I') {
                      handleBlockI();
                    } else if (block === 'Block J') {
                      handleBlockJ();
                    } else if (block === 'Block K and L') {
                      handleBlockKAndL();
                    } else if (block === 'Block M and N') {
                      handleBlockMAndN();
                    } else if (block === 'Part II') {
                      handlePartII();
                    } else if (block === 'Scrutiny Sheet') {
                      handleScrutinySheet();
                    } else {
                      handleBlockSelect(block);
                    }
                  }}
                >
                  {block}
                </button>
              ))}
            </div>

            {/* Middle + Right Column + Bottom Buttons */}
            <div className="columns-with-footer">
              <div className="blocks-row">
                {/* Middle Column */}
                <div className="block-column">
                  <h6 style={{ color: '#4caf50', marginBottom: '15px', textAlign: 'center' }}>Print Blocks</h6>
                  <button className="print-button" onClick={handleBlockAAndB}>Print Block A and B</button>
                  <button className="print-button" onClick={handleBlockC}>Print Block C</button>
                  <button className="print-button" onClick={handleBlockD}>Print Block D</button>
                  <button className="print-button" onClick={handleBlockE}>Print Block E</button>
                  <button className="print-button" onClick={handleBlockF}>Print Block F</button>
                  <button className="print-button" onClick={handleBlockG}>Print Block G</button>
                </div>

                {/* Right Column */}
                <div className="block-column">
                  <h6 style={{ color: '#4caf50', marginBottom: '15px', textAlign: 'center' }}>Print Blocks</h6>
                  <button className="print-button" onClick={handleBlockH}>Print Block H</button>
                  <button className="print-button" onClick={handleBlockI}>Print Block I</button>
                  <button className="print-button" onClick={handleBlockJ}>Print Block J</button>
                  <button className="print-button" onClick={handleBlockKAndL}>Print Block K and L</button>
                  <button className="print-button" onClick={handleBlockMAndN}>Print Block M and N</button>
                  <button className="print-button" onClick={handlePartII}>Print Block Part II</button>
                </div>
              </div>

              {/* Centered Below Buttons */}
              <div className="print-all-buttons-row">
                <button className="print-all-button" onClick={handleScrutinySheet}>
                  Print Scrutiny Sheet
                </button>
                <button className="print-all-button" onClick={handlePrintAllBlocks}>
                  Print all Blocks of ASI Return
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Action Buttons - Same as Validation.jsx */}
        <div className="row">
          <div className="col-12">
            <hr />
          </div>
          <div className="col-md-8 text-center text-md-start mb-3 mb-md-0">
            <button
              type="button"
              className="btn btn_orange mx-1"
              onClick={() => navigate('/asiScheduleMainMenu')}
            >
              Cancel
            </button>
          </div>
          <div className="col-md-4 text-center text-md-end">
            <button
              type="button"
              className="btn btn_orange mx-1"
              onClick={() => navigate(-1)}
            >
              <i className="fa fa-angle-left me-1"></i>
              Previous
            </button>
            <button
              type="button"
              className="btn btn_orange mx-1"
              onClick={() => navigate('/blockAandBreport')}
            >
              Next
              <i className="fa fa-angle-right ms-1"></i>
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default ReportSelection;
